module.exports = __webpack_public_path__ + "img/Analytic Reports-1.22d73a0a.svg";